import { useCallback, useEffect, useState } from "react";

import type { ProjectColor, ProjectSummary } from "@/features/board/types";
import { apiJson } from "@/lib/api";

type CreateProjectInput = {
  name: string;
  description: string;
  color: ProjectColor;
};

export const useProjects = () => {
  const [projects, setProjects] = useState<ProjectSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiJson<{ projects: ProjectSummary[] }>("/api/projects");
      setProjects(response.projects);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "Projects could not be loaded.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  const createProject = async (input: CreateProjectInput) => {
    const response = await apiJson<{ project: ProjectSummary }>("/api/projects", {
      method: "POST",
      body: JSON.stringify(input),
    });
    setProjects((current) => [response.project, ...current]);
    return response.project;
  };

  return { projects, loading, error, load, createProject };
};
